module.exports = __webpack_public_path__ + "static/media/kenPicture.7cac0a79.png";